import styled from 'styled-components';

export const OptionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const Question = styled.label`
  font-size: 14px;
`;

export const OptionAndLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 11px;
`;

export const OptionLabel = styled.label`
  text-align: center;
  cursor: pointer;
  :hover {
    font-weight: bold;
  }
`;

export const CommentTextArea = styled.textarea`
  width: 100%;
  resize: none;
  padding: 10px;
`;

export const CloseButton = styled.button`
  outline: 0;
  line-height: 10px;
  font-size: 25px;
  color: #505050;
  text-shadow: none;
  opacity: 1;
  cursor: pointer;
  padding: 15px;
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  background: white;
  font-weight: 600;
`;
